import styled from 'styled-components';

import colors from '../../../styles/colors';

export { ProfileCardCircleIconButton } from '../ClientQuickInfoButton/styles';

const StyledPersonIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.shades.secondary3};

  svg {
    width: 18px;
    height: 18px;
  }
`;

export { StyledPersonIcon };
